import * as CookieConsent from 'vanilla-cookieconsent';
import { gsap, lenis } from '../../global/gsap';

const initSplash = (element) => {
    const splashPlayed = sessionStorage.getItem('splashShown');

    const header = document.querySelector('.js-header');
    const heroLink = document.querySelector('.hero__link');
    const cookies = document.querySelector('.js-cookie-popup');

    const logo = element.querySelector('svg');
    const plus = logo.querySelector('.svg-plus');

    if (splashPlayed) {
        element.remove();
    } else {
        if (cookies) {
            gsap.set(cookies, {
                opacity: 0
            });
        }

        // Theme colours
        const colours = [
            '#FA681F',
            '#A1D984',
            '#FF515A',
            '#FFBF00',
            '#FEC1C4',
            '#EBDCA4'
        ];

        const randomColour = colours[Math.floor(Math.random() * colours.length)];

        gsap.set(logo, {
            y: '125%',
            fill: randomColour
        });

        gsap.set(plus, {
            transformOrigin: 'center center'
        });

        gsap.set([header, heroLink], {
            opacity: 0
        });

        const splashTl = gsap.timeline({
            defaults: {
                ease: 'power3.out',
                duration: 0.65
            },
            onStart: () => {
                window.scrollTo({ top: 0, left: 0, behavior: 'instant' });
                document.body.classList.add('stop-scrolling');
                lenis.stop();
            },
            onComplete: () => {
                document.body.classList.remove('stop-scrolling');
                lenis.start();
                element.classList.add('finish');
                sessionStorage.setItem('splashShown', true);

                gsap.to([header, heroLink], {
                    opacity: 1,
                    stagger: 0.25
                });

                // Check if cookie manager hasn't been responded to
                if (!document.cookie.split(';').some((item) => item.trim().startsWith('cc_cookie='))) {
                    CookieConsent.show();
                }
            }
        });

        splashTl.to(logo, {
            y: 0,
            delay: 0.5
        }).to(plus, {
            rotation: -180,
            transformOrigin: 'center center',
        }).to(logo, {
            duration: 0.5,
            scale: 0.75,
            opacity: 0
        }).to(element, {
            scaleY: 0,
            duration: 0.75,
            ease: 'power4.out'
        });
    }
};

export { initSplash as default };
